export default __webpack_public_path__ + "static/media/illustration-recruit-6-m.20470a95.webp";